module.exports = __webpack_public_path__ + "static/media/key.2bb92190.svg";